import axios from "axios";

const prepareData = (data) => {
  return { project_qa_ndt_bookings_inspector: data };
};

export const GET_PROJECT_QA_NDT_BOOKINGS_INSPECTORS = "get_project_qa_ndt_bookings_inspectors";
export const getProjectQaNdtBookingsInspectors = () => {
  const url = "/project/qa/ndt_bookings/inspectors.json";
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKINGS_INSPECTORS,
    payload: request,
  };
};

export const CREATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR = "create_project_qa_ndt_bookings_inspector";
export const createProjectQaNdtBookingsInspector = (data) => {
  const url = "/project/qa/ndt_bookings/inspectors.json";
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
    payload: request,
  };
};

export const GET_PROJECT_QA_NDT_BOOKINGS_INSPECTOR = "get_project_qa_ndt_bookings_inspector";
export const getProjectQaNdtBookingsInspector = (id) => {
  const url = `/project/qa/ndt_bookings/inspectors/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
    payload: request,
  };
};

export const UPDATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR = "update_project_qa_ndt_bookings_inspector";
export const updateProjectQaNdtBookingsInspector = (id, data) => {
  const url = `/project/qa/ndt_bookings/inspectors/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
    payload: request,
  };
};

export const DESTROY_PROJECT_QA_NDT_BOOKINGS_INSPECTOR = "destroy_project_qa_ndt_bookings_inspector";
export const destroyProjectQaNdtBookingsInspector = (id) => {
  const url = `/project/qa/ndt_bookings/inspectors/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_PROJECT_QA_NDT_BOOKINGS_INSPECTOR,
    payload: request,
  };
};
